const context = {
    Address: 'Address',
    Address2: 'Address, cont.',
    AddShippingAddress: 'Add new shipping address',
    AddressEntered: 'Address You Entered',
    AddressValidation: 'AddressValidation',
    Cancel: 'Cancel',
    City: 'City',
    Close: 'Close',
    ConfirmAddress: 'The address I entered is correct. Incorrect information may result in delay or cancellation of my order.',
    Delete: 'Delete',
    Edit: 'Edit',
    EditShippingAddress: 'Edit shipping address',
    FirstName: 'First Name',
    LastName: 'Last Name',
    LoadingSrText: 'Loading...',
    Phone: 'Phone',
    Primary: 'Primary',
    RequiredMessage: '{0} is required.',
    RequiredToken: '*',
    SaveAddress: 'Save Address',
    SelectSuggestedAddress: 'Please select one of the suggested options',
    SetPrimaryButton: 'Set as Primary',
    SetPrimaryCheckbox: 'Set as primary address',
    State: 'State',
    UnknownAddress: 'The address entered does not validate against any known address. Please cancel and edit the address, or confirm the address you entered is correct.',
    UpsCopyright: 'UPS, the UPS brand mark, and the Color Brown are trademarks of United Parcel Service of America, Inc. All Rights Reserved',
    UpsLogo: {
        Alt: 'UPS',
        Url: '/images-2/ups-logo.svg'
    },
    UseSuggestedAddress: 'Use Suggested Address',
    Zip: 'Zip'
};

export {
    context
};
